import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

import { MplChip } from '@mopla/ui';

import { useBookingRide } from '../BookingRideContext';

import { getRideStatusChipConfig } from './utils';

export const RideStatusChip: FC = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	const { rideStatus, rideTimeChange } = useBookingRide();

	const { label, variant, bgColor, textColor } = useMemo(
		() => getRideStatusChipConfig(rideStatus, rideTimeChange.type, t, theme),
		[rideStatus, rideTimeChange.type, t, theme]
	);

	if (!label) return null;

	return (
		<MplChip
			label={label}
			variant={variant}
			bgColor={bgColor}
			textColor={textColor}
			dataTestId="rideStatus-chip"
		/>
	);
};
